<template>
    <div class="boxes">
        <div class="box">
            <div class="box-heading border-bottom">
                <h5>注册账户（注册涉及到其它库，可能需要等很久才能注册成功。）</h5>
            </div>
            <form class="w-50" @submit.prevent="bindAccount">
                <div class="form-group">
                    <label>请选择服务端</label>
                    <select class="form-control" v-model="server_id" @change="changeServerId">
                        <option value="0">请选择服务端</option>
                        <option v-for="server in servers" v-bind:value="server.id" v-text="server.server_name" ></option>
                    </select>
                </div>
                <div class="form-group">
                    <label>私服账户</label>
                    <input type="text" v-model="account" class="form-control" placeholder="请输入私服账户">
                </div>
                <div class="form-group">
                    <label>私服账户的姓名（用于找回密码）</label>
                    <input type="text" v-model="name" class="form-control" placeholder="请输入私服账户的名称">
                </div>
                <div class="form-group">
                    <label>登录密码</label>
                    <input type="password" v-model="password" class="form-control" placeholder="请设置登录密码">
                </div>
                <button type="submit" class="btn btn-primary rounded">立即注册</button>
            </form>
        </div>
    </div>
</template>

<script>
    import {mapGetters} from 'vuex';

    export default {
        data() {
            return {
                account: '',
                name: '',
                password:'',
                servers: {},
                server_id: 0,
            }
        },
        computed: {
            ...mapGetters(['currentUser'])
        },
        created() {
            this.getServers();
        },
        methods: {
            getServers() {
                this.$http.get('asktao/servers')
                .then((res) => {
                    this.servers = res.data;

                    for(let item of this.servers) { //item为list中的对象
                        if(item.is_default == 1){
                            this.server_id = item.id;
                            break;
                        }
                    }
                });
            },
            changeServerId(e){
                this.server_id = e.target.value;
            },
            async bindAccount() {
                if(parseInt(this.server_id) <= 0){
                    this.$message.error('请选择服务端');
                    return false;
                }
                if(!this.account){
                    this.$message.error('请输入私服账户！');
                    return false;
                }
                await this.$http.post('asktao/register', {
                    server_id: parseInt(this.server_id),
                    user_name: this.account,
                    password: this.password,
                    name: this.name,
                }).then((res) => {
                    this.account = this.password = this.name = '';
                    this.$message.success(res.msg);
                })
                .catch((e) => {
                    // this.$message.error(e);
                });
            },
        }
    }
</script>
